import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { RefdataProvider } from '../../providers/refdata/refdata'
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';

/**
 * Generated class for the BeerInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-info',
  templateUrl: 'beer-info.html',
  styleUrls: ['./beer-info.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class BeerInfoComponent implements OnInit, OnDestroy, AfterViewInit {

  //_bnaam: string = 'nog geen naam...';

  _bn: string;
  _bd: any;

  @Input()
  set bnaam(n: string) {
    this._bn = n;
  }
  get bnaam() {
    return this._bn;//this._bnaam;
  }

  @Input()
  set beerdata(d: any) {
    console.log("[beer-info] set beerdata to " + this.bhutil.stringify(d));
    this._bd = d;

    //this.beerdata.beer.logoUrl = this.getImageUrl(d);
    if(this._bd && this._bd.beer) {
      //we are coming in through the wishlist
      this._bd.beer.logoUrl = this.getImageUrl(this._bd.beer);
      if (this._bd.beer.abv === undefined || this._bd.beer.abv == null)
        this.abv = null;
      else
        this.abv = this._bd.beer.abv.toFixed(1);
      if (this._bd.beer.ebc === undefined)
        this.ebc = 0;
      else
        this.ebc = this._bd.beer.ebc;
      if (this._bd.beer.ibu === undefined)
        this.ibu = 0;
      else
        this.ibu = this._bd.beer.ibu;

      if (this.abv == null) {
        this.abvActive = false;
      }
      else {
        this.abvActive = true;
      }
      if (this.ebc == 0) {
        this.ebcActive = false;
      }
      else {
        this.ebcActive = true;
      }
      if (this.ibu == 0) {
        this.ibuActive = false;
      }
      else {
        this.ibuActive = true;
      }
    }

  }
  get beerdata() {
    return this._bd;
  }

  //@Input() bnaam: string;

  beername: string;
  breweryname: string;
  brewerylocation: string;
  imageURL: string;
  baseURL: string;
  addendumBeer: string;
  addendumBrewery: string;
  abv: number;
  ibu: number;
  ebc: number;

  abvActive: boolean;
  ebcActive: boolean;
  ibuActive: boolean;

  ngAfterViewInit() {
    console.log("[beer-info] - ngAfterViewInit called");
    this.updateInfo();
  }

  private showBeerInfoSubscription: any;

  constructor(
    private events: AppEventService, private refdata: RefdataProvider, private bhutil: BhutilProvider
  ) {
    let thedata = this._bd;

    this.showBeerInfoSubscription = (newbeer: any) => {
      console.log("[beer-info] - showBeerInfoSubscription called with newbeer = " + (newbeer ? JSON.stringify(newbeer) : "undefined"));
      this.beername = "";
      let olddata = this.beerdata;
      olddata.beer.naam = "Tralala";
      this.beerdata = olddata;

      this.abvActive = true;
      this.ebcActive = true;
      this.ibuActive = true;

      if (newbeer.abv === undefined || newbeer.abv == null)
        this.abv = null;
      else
        this.abv = newbeer.abv.toFixed(1);
      if (newbeer.ebc === undefined)
        this.ebc = 0;
      else
        this.ebc = newbeer.ebc;
      if (newbeer.ibu === undefined)
        this.ibu = 0;
      else
        this.ibu = newbeer.ibu;

      if (this.abv == null) {
        this.abvActive = false;
      }
      else {
        this.abvActive = true;
      }
      if (this.ebc == 0) {
        this.ebcActive = false;
      }
      else {
        this.ebcActive = true;
      }
      if (this.ibu == 0) {
        this.ibuActive = false;
      }
      else {
        this.ibuActive = true;
      }

      //this.beerdata.beer = newbeer;

      let newbeerdata: any = {};
      newbeerdata.beer = newbeer.beer;
      newbeerdata.brewery = newbeer.brewery;
      newbeerdata.beer.logoUrl = this.getImageUrl(newbeer.beer);
      this.beerdata = newbeerdata;
    };
    this.events.subscribe("similar-beers:show:beer-info", this.showBeerInfoSubscription);
  }

  ngOnInit() {
    this.events.subscribe("beer-detail:show:beer-info", this.showBeerInfoSubscription);
  }
  ngOnDestroy() {
    this.events.unsubscribe("similar-beers:show:beer-info", this.showBeerInfoSubscription);
    this.events.unsubscribe("beer-detail:show:beer-info", this.showBeerInfoSubscription);
  }

  updateInfo() {
    console.log("[beer-info] - updateInfo called with _bd = " + (this._bd ? JSON.stringify(this._bd) : "undefined"));
    if (!this._bd)
      return;

    if (this._bd.beer.abv == "") {
      this._bd.beer.abv = null;
    }
    let newabv = (this._bd.beer.abv != null ? this._bd.beer.abv.toFixed(1) : null);
    this.abv = (this._bd.beer.abv != null ? this._bd.beer.abv.toFixed(1) : null);
    this.ibu = (this._bd.beer.ibu && this._bd.beer.ibu != null ? this._bd.beer.ibu : 0);
    this.ebc = (this._bd.beer.ebc && this._bd.beer.ebc != null ? this._bd.beer.ebc : 0);

    //console.log("EBC**" + this.ebc + "**");

    if (this.abv === undefined || this.abv == null) {
      this.abvActive = false;
    }
    else {
      this.abvActive = true;
    }
    if (this.ebc === undefined || this.ebc == 0) {
      this.ebcActive = false;
    }
    else {
      this.ebcActive = true;
    }
    if (this.ibu === undefined || this.ibu == 0) {
      this.ibuActive = false;
    }
    else {
      this.ibuActive = true;
    }
  }

  getImageUrl(b: any) {
    //console.log("getImageUrl for beer with id: " + b.beer.id);
    if (!b) {
      console.log("[beer-info].getImageUrl: no beer passed");
    }
    if (!b.brewery) {
      console.log("[beer-info].getImageUrl: no brewery passed");
    }

    if (b.logo !== undefined && b.logo != null && b.logo !== "") {
      let logoUrlBeer = this.refdata.getEnvVar('beerLogoBaseUrl') + b.logo;
      //console.log("LOGO - using beer logo: " + logoUrlBeer);
      return logoUrlBeer;
    } else if (b.brewery.logo !== undefined && b.brewery.logo != null) {
      let logoUrlBrewery = this.refdata.getEnvVar('breweryLogoBaseUrl') + b.brewery.logo;
      //console.log("LOGO - using brewery logo: " + logoUrlBrewery);
      return logoUrlBrewery;
    }
    else {
      let logoNoLogo = "../assets/svg/icon_beerglass.svg";
      //console.log("LOGO - using placeholder logo (no_logo: " + logoNoLogo);
      return logoNoLogo;
    }
  }

}
